import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import parse from 'html-react-parser';

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqPOST, reqPUT, reqDELETE, translate } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { companycode } from "../../../../Hosts";

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
        
    const entities_list = useRef(null);
    const trainees_list = useRef(null);

    const classificacao_eficacia_list = useRef(null);
    const formation_state_list = useRef(null);

    const formation_list = useRef(null);
    const formation_list_active = useRef(null);
    const formation_active = useRef(null);
    const new_year = useRef(null);
    const year_active = useRef(null);
    const years_actives = useRef(null);
        
    const audit_types = useRef(null);
    const new_row = useRef(null);
    const active_row = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0);
    
    const fetch_quality_attributes = async (type) => {

        let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}/active`)
        let result = []
        if (res.data !== undefined) {
            for await (let el of res.data) {

                let aux = {
                    id: el.id,
                    name: translate(el.info.title, 'pt')
                }

                result.push(aux)
            }
        }

        return result

    }

    const fetch_entities_list = async (id) => {

        let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
        let result = []
        if (res.data !== undefined) {
            result = res.data.filter(el => parseInt(el.entity_type) === parseInt(id))
        }

        return result

    }

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const get_attr = async () => {

        let res_1 = await fetch_quality_attributes('formation_classification_type')
        if (res_1.length > 0) {
            // res_1 = order_array(res_1)

            let res_aux_1 = []
            for await (let el of res_1) {
                res_aux_1.push({
                    id: el.id,
                    label: el.name
                })
            }
            set_dados(classificacao_eficacia_list.current = res_aux_1)
        }

        let res_2 = await fetch_quality_attributes('formation_state_type')
        if (res_2.length > 0) {
            // res_2 = order_array(res_2)

            let res_aux_2 = []
            for await (let el of res_2) {
                res_aux_2.push({
                    id: el.id,
                    label: el.name
                })
            }
            set_dados(formation_state_list.current = res_aux_2)
        }
        let res_5 = await fetch_entities_list('2')
            if (res_5.length > 0) {
                res_5 = order_array(res_5)

                let res_aux_5 = []
                for await (let el of res_5) {
                    res_aux_5.push({
                        id: el.id,
                        label: el.name,
                        email: el.email
                    })
                }
                set_dados(entities_list.current = res_aux_5)
            }
            let res_6 = await fetch_entities_list('1')
            if (res_6.length > 0) {
                res_6 = order_array(res_6)

                let res_aux_6 = []
                for await (let el of res_6) {
                    res_aux_6.push({
                        id: el.id,
                        label: el.name,
                        email: el.email
                    })
                }
                set_dados(trainees_list.current = res_aux_6)
            }


        return true

    }
    

    const get_info = async () => {

        let res_1 = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/audit_type`)
        set_dados(audit_types.current = res_1.data)

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(async res => {
                if (res.data[0] !== undefined) {
                    set_dados(formation_list.current = res.data);

                    let aux = 0
                    let array_aux = []
                    let array_ano_aux = []
                    for await (let el of res.data) {

                        let aux_2 = array_ano_aux.filter(e => parseInt(e.info.name) === parseInt(el.info.name))
                        if(Array.isArray(aux_2) && aux_2.length === 0) {
                            if(el.info.name !== '') {
                                array_ano_aux.push({
                                    id: '',
                                    info: {
                                        name: el.info.name
                                    }
                                })
                            }
                        }

                    }

                    set_dados(years_actives.current = array_ano_aux)

                    if(Array.isArray(array_ano_aux) && array_ano_aux.length > 0) {
                        set_dados(year_active.current = array_ano_aux[0].info.name)

                        if(array_ano_aux[0]?.info?.name !== undefined && array_ano_aux[0]?.info?.name !== null && array_ano_aux[0].info.name !== '') {
                            change_year(year_active.current)
                        }
                    }

                }
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            set_dados(entities_list.current = [])
            set_dados(trainees_list.current = [])
            set_dados(classificacao_eficacia_list.current = [])
            set_dados(formation_state_list.current = [])
            set_dados(year_active.current = '')

            await get_info()
            await get_attr()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_state = (element) => {

        let result = '<span className="badge rounded-0 text-dark p-3 fs-6">' + language[lang].action_not_open + '</span>'

        if(element?.info?.action?.analysis?.ac_am !== undefined) {

            if(element.info.action.analysis.ac_am === true) {

                if(element?.info?.action?.results?.responsable?.execution !== undefined && element?.info?.action?.results?.responsable?.execution !== null && element.info.action.results.responsable.execution !== '') {
                    if(element?.info?.action?.results?.value !== undefined && parseInt(element.info.action.results.value) === 1) {
                        result = '<span className="badge rounded-0 bg-success p-3 fs-6">' + language[lang].effective + '</span>'
                    }
                    else if(element?.info?.action?.results?.value !== undefined && element?.info?.action?.results?.value !== null && parseInt(element.info.action.results.value) === 0) {
                        result = '<span className="badge rounded-0 bg-danger p-3 fs-6">' + language[lang].not_effective + '</span>'
                    }
                }
                else if(element?.info?.action?.improvement?.responsable?.execution !== undefined && element?.info?.action?.improvement?.responsable?.execution !== null && element.info.action.improvement.responsable.execution !== '') {
                    result = '<span className="badge rounded-0 bg-warning text-dark p-3 fs-6">' + language[lang].for_evaluating + '</span>'
                }
                else {
                    result = '<span className="badge rounded-0 bg-orange text-dark p-3 fs-6">' + language[lang].action_to_be_taken + '</span>'
                }

            }
        }

        return result
    }
    
    const columns = [
        {
            name: language[lang].field_number,
            selector: 'info.number',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_type,
            selector: 'info.settings.occurrence_type',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_date,
            selector: 'info.action.identification.notification',
            cell: row => (
                <span style={{
                    fontFamily: 'monospace',
                    fontVariantNumeric: 'tabular-nums',
                }}>
                    {row?.info?.action?.identification?.responsable?.notification !== undefined && row.info.action.identification.responsable.notification !== '' ? row.info.action.identification.responsable.notification.split('T')[0] : ''}
                </span>
            ),
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '45% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_state,
            cell: row => (
                parse(get_state(row))
            ),
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        Array.isArray(row.info.file.pdf) && row.info.file.pdf.length > 0 ?
                            <a className="button button-update button-view p-0 pe-2" href={row.info.file.pdf[row.info.file.pdf.length - 1].link} target='_blank'>
                                <i className="bi bi-eye"></i>
                            </a>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const add_new_year = async () => {


        const { value: year } = await Swal.fire({
            input: "text",
            inputLabel: "Ano",
            inputPlaceholder: "Inserir o ano"
        });

        if (year !== '') {
            if(!Array.isArray(years_actives.current)) {
                years_actives.current = []
            }

            set_dados(new_year.current = year)
            set_dados(year_active.current = year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: year
                }
            }))

            change_year(year)

            setRefresh(r => r + 1)

        }


        /*
        if(years_actives.current !== undefined && years_actives.current !== null && years_actives.current.length > 0) {

            let last_year = years_actives.current[years_actives.current.length - 1]
            let aux_year = parseInt(last_year.info.name) + 1
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: aux_year
                }
            }))

            change_year(aux_year)

        }
        else {
            let aux_year = new Date().getFullYear()
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            let aux = {
                id: '',
                info: {
                name: aux_year
            }
            }

            set_dados(years_actives.current = [aux])

            change_year(aux_year)
        }

        */
    }

    const change_year = async (year) => {


        console.log('year', year)
        console.log('years_actives.current', years_actives.current)


        if(formation_list.current !== undefined && formation_list.current !== null && formation_list.current.length > 0) {

            let aux = []
            for await (let el of formation_list.current) {

                if(el.info.name.toString() === year.toString()) {    
                    aux.push(el)        
                }

                console.log('1111111')

            }
            set_dados(formation_list_active.current = aux)


            console.log('formation_list_active.current', formation_list_active.current)
        }
        else {
            let aux = {
                id: '',
                info: {
                    name: year,
                    companycode: getTokenInfo().companycode,
                    type: 'formation',
                    settings: []
                }
            }
            set_dados(formation_active.current = aux)

            
                console.log('222222')

        }

    }


    const add_row = () => {

        // if(new_row.current === undefined || new_row.current === null) {
            new_row.current = []
        // }

        set_dados(new_row.current.push({
            id: Date.now(),
            // info: {
            //     companycode: getTokenInfo().companycode,
            //     type: 'formation',
            //     name: year_active.current,
            //     settings: []
            // }
        }))

        // set_dados(formation_list_active.current.push(new_row.current[0]))

        setRefresh(r => r + 1)

    }

	const change_settings = (e) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset
		
		if (new_row.current === undefined) {
			new_row.current = []
		}

		new_row.current.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {

                if(name === 'formation_entity') {
                    if (el.formation_entity_ === undefined) {
                        el.formation_entity_ = {}
                    }

                    let x = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el.formation_entity_ = aux
                        el[name] = aux.name
                    }
                }
                else if(name === 'eficacia_global') {
                    if (el.eficacia_global_ === undefined) {
                        el.eficacia_global_ = {}
                    }

                    let x = classificacao_eficacia_list.current.filter(el => parseInt(el.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el.eficacia_global_ = aux
                        el[name] = aux.name
                    }
                }
                else if(name === 'state') {
                    if (el.state_ === undefined) {
                        el.state_ = {}
                    }

                    let x = formation_state_list.current.filter(el => parseInt(el.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el.state_ = aux
                        el[name] = aux.name
                    }
                }
                else {
                    el[name] = value
                }
			}
		})

		set_dados(new_row.current, )

        
		setRefresh(r => r + 1)

		console.log('new_row.current', new_row.current)

	}

    const save_row = async () => {

        if(formation_active.current === undefined || formation_active.current === null) {
            formation_active.current = {
                id: '',
                info: {
                    companycode: getTokenInfo().companycode,
                    type: 'formation',
                    name: year_active.current
                }
            }
        }
        if(formation_active.current.info.settings === undefined || formation_active.current.info.settings) {
            formation_active.current.info.settings = []
        }

        formation_active.current.info.settings.push(new_row.current[0])

        if(formation_active.current.id === '') {
            await reqPOST(api_crud_route, formation_active.current)
        }
        else {
            await reqPUT(api_crud_route, formation_active.current)
        }

        let aux = await reqGET(api_list_route(getTokenInfo().companycode))
        set_dados(formation_list_active.current = aux.data)

        set_dados(new_row.current = [])

        setRefresh(r => r + 1)

    }

    const edit_row = async (el) => {

        set_dados(formation_active.current = el)
        // let aux = []
        // aux.push(el)
        // set_dados(active_row.current = aux)
        set_dados(new_row.current = el.info.settings)

        console.log('formation_active.current', formation_active.current)
        console.log('active_row.current', active_row.current)


    }

    const add_row_trainees = async (el) => {

        console.log('el', el)

        el.info.settings.forEach((e) => {

            // if(parseInt(e.id) === parseInt(el.id)) {
                if(e.trainees === undefined || e.trainees === null) {
                    e.trainees = []
                }
                e.trainees.push({
                    id: Date.now()
                })
            // }
        })

        set_dados(formation_active.current = el)
        set_dados(new_row.current = el.info.settings)

        setRefresh(r => r + 1)
        console.log('new_row.current', new_row.current)

    }

    const remove_row_trainees = async (id_settings, id_trainee, el) => {

        console.log('el', el)

        let aux_trainees = []
        el.info.settings.forEach((el_s) => {
            if(parseInt(el_s.id) === parseInt(id_settings)) {
                el_s.trainees.forEach((el_t) => {
                    if(parseInt(el_t.id) !== parseInt(id_trainee)) {
                        aux_trainees.push(el_t)
                    }
                })

                el_s.trainees = aux_trainees
            }
        })

        set_dados(formation_active.current = el)

        setRefresh(r => r +1)

    }


    const change_trainees_values = async (e, el) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset

        console.log('el', el)
        console.log('name', name)
        console.log('value', value)
        console.log('id', id)

        el.info.settings[0].trainees.forEach((el_t) => {
            if(parseInt(el_t.id) === parseInt(id)) {

                if(name === 'trainee') {
                    if (el_t.trainee === undefined) {
                        el_t.trainee = {}
                    }

                    let x = trainees_list.current.filter(el_ => parseInt(el_.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el_t.trainee = aux
                        el_t['trainee_name'] = aux.name
                    }
                }
                else if(name === 'external_responsable') {
                    if (el_t.external_responsable_ === undefined) {
                        el_t.external_responsable_ = {}
                    }

                    let x = entities_list.current.filter(el_ => parseInt(el_.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el_t.external_responsable_ = aux
                        el_t['external_responsable'] = aux.name
                    }
                }
                else if(name === 'internal_responsable') {
                    if (el_t.internal_responsable_ === undefined) {
                        el_t.internal_responsable_ = {}
                    }

                    let x = entities_list.current.filter(el_ => parseInt(el_.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el_t.internal_responsable_ = aux
                        el_t['internal_responsable'] = aux.name
                    }
                }
                else if(name === 'eficacia') {
                    if (el_t.eficacia_ === undefined) {
                        el_t.eficacia_ = {}
                    }

                    let x = classificacao_eficacia_list.current.filter(el_ => parseInt(el_.id) === parseInt(value))
                    if(Array.isArray(x) && x.length > 0) {
                        let aux = {
                            id: x[0].id,
                            name: x[0].label
                        } 

                        el_t.eficacia_ = aux
                        el_t['eficacia'] = aux.name
                    }
                }
                else {
                    el_t[name] = value
                }
            }

            setRefresh(r => r + 1)
        })

        set_dados(formation_active.current = el)
        set_dados(new_row.current = el.info.settings)

        await reqPUT(api_crud_route, formation_active.current)
        
        setRefresh(r => r + 1)
        console.log('new_row.current', new_row.current)

    }

    return (isloading ?

        <Loader />

    :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                    </div>
                                    <div className="table-body">
 
                                        <div className="row">
                                            <div className="col-6 mb-3 d-flex">
                                                {
                                                (new_row.current === undefined || new_row.current === null || new_row.current.length === 0) && 
                                                years_actives.current !== undefined && years_actives.current !== null ?
                                                    years_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el.info.name) === parseInt(year_active.current) ? ' active' : '' )} onClick={() => change_year(dt_el.info.name)} >{parseInt(dt_el.info.name)}</button>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    null
                                                }
                                                {
                                                (new_row.current === undefined || new_row.current === null || new_row.current.length === 0) ?
                                                    <div>
                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2"} onClick={() => add_new_year()}><i className="bi bi-plus"></i> {language[lang].add_new_year}</button>
                                                    </div>
                                                :
                                                    null
                                                }
                                            </div>
                                            <div className="col-6 mb-3">
                                                <div className="row">
                                                    {
                                                    (new_row.current === undefined || new_row.current === null || new_row.current.length === 0) && 
                                                    year_active?.current !== undefined && year_active?.current !== null && year_active.current !== '' && year_active.current.name !== '' ?
                                                        <div className='col-12 text-end'>
                                                            <button type="button" className='btn btn-sm btn-outline-secondary rounded-pill mb-2' onClick={() => add_row()}>{language[lang].add_new}</button>
                                                        </div>
                                                    :
                                                        <div className='col-12 text-end'>
                                                            <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2"} onClick={() => set_dados(new_row.current = [])}> {language[lang].back}</button>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="col-12 mb-3">
                                                <div className="row">
                                                    {
                                                    (new_row.current === undefined || new_row.current === null || new_row.current.length === 0) && 
                                                    year_active?.current !== undefined && year_active?.current !== null && year_active.current.name !== '' && 
                                                    formation_list_active?.current !== undefined && formation_list_active?.current !== null && formation_list_active.current.length > 0 ?
                                                        <div className="div-table">
                                                            <div className="table-header text-end mb-8">
                                                            </div>
                                                            <div className="table-body">
                                                                <div className="row">
                                                                    <div className="col-12 mb-3">
                                                                        <div className="mb-5"> 
                                                                            <div className="div-table">
                                                                                <div className="table-body table-responsive">
                                                                                    <table className="table formation-list table-hover table-bordered align-middle">
                                                                                        <thead className="text-center align-middle">
                                                                                            <tr>
                                                                                                <th className="lh-lg p-3">
                                                                                                    {language[lang].field_number}
                                                                                                </th>
                                                                                                <th className="lh-lg p-3">
                                                                                                    {language[lang].field_designation}
                                                                                                </th>
                                                                                                <th className="lh-lg p-3">
                                                                                                    {language[lang].field_aprovation_date}
                                                                                                </th>
                                                                                                <th className="lh-lg p-3">
                                                                                                    {language[lang].table_state}
                                                                                                </th>
                                                                                                <th className="lh-lg p-3"></th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                            formation_list_active.current.map((el_fla, k_fla) => {
                                                                                                return (
                                                                                                    el_fla.info.settings.map((el_fl, key_fl) => {
                                                                                                        return(
                                                                                                            <tr key={k_fla}>
                                                                                                                <td className="text-center">{k_fla + 1}</td>
                                                                                                                <td>{el_fl.name}</td>
                                                                                                                <td className="text-center">
                                                                                                                    <span style={{
                                                                                                                        fontFamily: 'monospace',
                                                                                                                        fontVariantNumeric: 'tabular-nums',
                                                                                                                    }}>
                                                                                                                        {el_fl.date}
                                                                                                                   </span>
                                                                                                                </td>
                                                                                                                <td className="text-center">{el_fl.state}</td>
                                                                                                                <td className="text-center">
                                                                                                                    <button type="button" className='button button-update p-0 ps-2' onClick={() => edit_row(el_fla)}>
                                                                                                                        <span><i className="bi bi-pencil"></i></span>
                                                                                                                    </button>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )
                                                                                                    })
                                                                                                )
                                                                                            })
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    :
                                                        null
                                                    }
                                                </div>

                                                <div className="row">
                                                    <div className='col-12'>
                                                        {
                                                        new_row.current !== undefined && new_row.current !== null ?
                                                            new_row.current.map((el_settings, key_settings) => {
                                                                return (
                                                                    <div  key={key_settings} className="card">
                                                                        <div className="card-body border mb-5">

                                                                            <div className={'row p-3' + (key_settings % 2 !== 0 ? ' bg-light' : '')}>

                                                                                <div className="col-6 col-md-6 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_designation}</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="name"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.name !== undefined && el_settings?.name !== null ? el_settings?.name : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>

                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_aprovation_date}</label>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="date"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.date !== undefined && el_settings?.date !== null ? el_settings?.date : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>

                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].table_state}</label>

                                                                                    <select
                                                                                        name="state"
                                                                                        data-id={el_settings.id}
                                                                                        className="form-select form-control mb-2 rounded-0"
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        value={el_settings?.state_?.id !== undefined && el_settings?.state_?.id !== null ? el_settings.state_.id : ''}
                                                                                    >
                                                                                        <option value="">{language[lang].field_choose}</option>
                                                                                        {
                                                                                        formation_state_list.current !== undefined && formation_state_list.current !== null ?
                                                                                            formation_state_list.current.map((el_el, k_el) => (
                                                                                                <option key={k_el} value={el_el.id}>
                                                                                                    {el_el.label}
                                                                                                </option>
                                                                                            ))
                                                                                        :
                                                                                            null
                                                                                        }
                                                                                    </select>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="state"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.state !== undefined && el_settings?.state !== null ? el_settings?.state : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0 d-none" />
                                                                                </div>
                                                                                
                                                                                <div className="col-12"></div>
                                                                                
                                                                                <div className="col-6 col-md-6 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_objectives}</label>
                                                                                    <textarea 
                                                                                        type="text" 
                                                                                        rows="4" 
                                                                                        name="objectives" 
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.objectives !== undefined && el_settings?.objectives !== null ? el_settings?.objectives : ''}
                                                                                        onChange={(e) => change_settings(e)} 
                                                                                        className="form-control rounded-0" 
                                                                                    />
                                                                                </div>
                                                                                
                                                                                <div className="col-6 col-md-6 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_to_evaluate}</label>
                                                                                    <textarea 
                                                                                        type="text" 
                                                                                        rows="4" 
                                                                                        name="evaluation" 
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.evaluation !== undefined && el_settings?.evaluation !== null ? el_settings?.evaluation : ''}
                                                                                        onChange={(e) => change_settings(e)} 
                                                                                        className="form-control rounded-0" 
                                                                                    />
                                                                                </div>
                                                                            
                                                                                <div className="col-12"></div>
                                                                                
                                                                                <div className="col-6 col-md-6 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_formation_entity}</label>
                                                                                    <select
                                                                                        name="formation_entity"
                                                                                        data-id={el_settings.id}
                                                                                        className="form-select form-control mb-2 rounded-0"
                                                                                        onChange={change_settings}
                                                                                        value={el_settings?.formation_entity_?.id !== undefined && el_settings?.formation_entity_?.id !== null ? el_settings.formation_entity_.id : ''}
                                                                                    >
                                                                                        <option value="">{language[lang].field_choose}</option>
                                                                                        {
                                                                                        entities_list.current !== undefined && entities_list.current !== null ?
                                                                                            entities_list.current.map((el_el, k_el) => (
                                                                                                <option key={k_el} value={el_el.id}>
                                                                                                    {el_el.label}
                                                                                                </option>
                                                                                            ))
                                                                                        :
                                                                                            null
                                                                                        }
                                                                                    </select>

                                                                                    <input
                                                                                        type="text"
                                                                                        name="formation_entity"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.formation_entity !== undefined && el_settings?.formation_entity !== null ? el_settings?.formation_entity : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0 d-none" 
                                                                                    />
                                                                                </div>
                                                                            
                                                                                <div className="col-6 col-md-6 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_formation_local}</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="formation_local"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.formation_local !== undefined && el_settings?.formation_local !== null ? el_settings?.formation_local : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>
                                                                                
                                                                                <div className="col-12"></div>
                                                                                
                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_begin}</label>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="date_prevista_begin"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.date_prevista_begin !== undefined && el_settings?.date_prevista_begin !== null ? el_settings?.date_prevista_begin : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>

                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_end}</label>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="date_prevista_end"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.date_prevista_end !== undefined && el_settings?.date_prevista_end !== null ? el_settings?.date_prevista_end : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>

                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_hours}</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="horas_previstas"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.horas_previstas !== undefined && el_settings?.horas_previstas !== null ? el_settings?.horas_previstas : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>
                                                                                
                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_begin_real}</label>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="date_efectiva_begin"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.date_efectiva_begin !== undefined && el_settings?.date_efectiva_begin !== null ? el_settings?.date_efectiva_begin : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" />
                                                                                </div>
                                                                                
                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_date_end_real}</label>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="date_efectiva_end"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.date_efectiva_end !== undefined && el_settings?.date_efectiva_end !== null ? el_settings?.date_efectiva_end : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" 
                                                                                    />
                                                                                </div>

                                                                                <div className="col-4 col-md-2 mt-3">
                                                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_hours_real}</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="horas_efectivas"
                                                                                        data-id={el_settings.id}
                                                                                        value={el_settings?.horas_efectivas !== undefined && el_settings?.horas_efectivas !== null ? el_settings?.horas_efectivas : ''}
                                                                                        onChange={(e) => change_settings(e)}
                                                                                        className="form-control rounded-0" 
                                                                                    />
                                                                                </div>

                                                                                <div className='col-12 mt-3 text-end'>
                                                                                    <button type="button" className='btn btn-sm btn-outline-secondary rounded-pill me-2' onClick={() => save_row()}>{language[lang].save}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div className="card-body">
                                                                            <div className={'row p-3' + (key_settings % 2 !== 0 ? ' bg-light' : '')}>

                                                                                <div className='col-12 mb-3 text-end d-none'>
                                                                                    <button type="button" className='btn btn-sm btn-outline-secondary rounded-pill me-2' onClick={() => add_row_trainees(formation_active.current)}>{language[lang].add_new}</button>
                                                                                </div>
                                                                                <div className='col-12'>
                                                                                    <div className="div-table">
                                                                                        <div className="table-body table-responsive">
                                                                                            <table className="table formation-list table-hover table-bordered align-middle">
                                                                                                <thead className="text-center align-middle">
                                                                                                    <tr>
                                                                                                        <th rowSpan={4} className="text-white p-3" style={{minWidth: '250px', zIndex: 9}}>
                                                                                                            <div>{language[lang].field_trainee_names}</div>
                                                                                                            <button type="button" className='btn btn-sm btn-secondary rounded-pill mt-3' onClick={() => add_row_trainees(formation_active.current)}>{language[lang].add_new}</button>
                                                                                                        </th>
                                                                                                        <th colSpan={9} className="text-white p-3 position-relative" style={{zIndex: 9}}>
                                                                                                            {language[lang].field_formation_efficiency}
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                    <tr className="text-white p-3" style={{zIndex: 5}}>
                                                                                                        <th rowSpan={3} className="border-end p-3" style={{minWidth: '100px'}}>
                                                                                                            {language[lang].field_participated}
                                                                                                        </th>
                                                                                                        <th rowSpan={3} className="p-3">
                                                                                                            <span style={{
                                                                                                                fontFamily: 'monospace',
                                                                                                                fontVariantNumeric: 'tabular-nums',
                                                                                                            }}>
                                                                                                                {language[lang].field_date_conclusion}
                                                                                                            </span>
                                                                                                        </th>
                                                                                                        <th colSpan={3} className="p-3">{language[lang].field_external_evaluation}</th>
                                                                                                        <th colSpan={2} className="p-3">{language[lang].field_internal_evaluation}</th>
                                                                                                        <th rowSpan={4} className="p-3">{language[lang].field_global_evaluation}</th>
                                                                                                        <th rowSpan={4} className="p-3" style={{minWidth: '200px'}}>{language[lang].field_efffectiveness_trainee}</th>
                                                                                                    </tr>
                                                                                                    <tr className="text-white p-3" style={{zIndex: 5}}>
                                                                                                        <th className="border-end p-3" style={{minWidth: '100px'}}>
                                                                                                            {language[lang].field_existed}
                                                                                                        </th>
                                                                                                        <th className="p-3" style={{minWidth: '250px'}}>
                                                                                                            {language[lang].field_who_evaluated}
                                                                                                        </th>
                                                                                                        <th className="border-start border-end p-3">
                                                                                                            {language[lang].field_classification}
                                                                                                        </th>
                                                                                                        <th className="border-end p-3"  style={{minWidth: '250px'}}>
                                                                                                            {language[lang].field_who_evaluated}
                                                                                                        </th>
                                                                                                        <th className="p-3">
                                                                                                            {language[lang].field_classification}
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    {
                                                                                                    el_settings !== undefined && el_settings?.trainees !== undefined && Array.isArray(el_settings.trainees) ?
                                                                                                        el_settings.trainees.map((el_t, k_t) => {
                                                                                                            return (
                                                                                                                <tr key={k_t}>
                                                                                                                    <td className={k_t % 2 === 0 ? "bg-white" : "bg-light"}>

                                                                                                                        <div className="input-group">
                                                                                                                            <select
                                                                                                                                name="trainee"
                                                                                                                                data-id={el_t.id}
                                                                                                                                className="form-select form-control rounded-0"
                                                                                                                                onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                                value={el_t?.trainee?.id !== undefined && el_t?.trainee?.id !== null ? el_t.trainee.id : ''}
                                                                                                                            >
                                                                                                                                <option value="">{language[lang].field_choose}</option>
                                                                                                                                {
                                                                                                                                trainees_list.current !== undefined && trainees_list.current !== null ?
                                                                                                                                    trainees_list.current.map((el_el, k_el) => (
                                                                                                                                        <option key={k_el} value={el_el.id}>
                                                                                                                                            {el_el.label}
                                                                                                                                        </option>
                                                                                                                                    ))
                                                                                                                                :
                                                                                                                                    null
                                                                                                                                }
                                                                                                                            </select>
                                                                                                                            <input
                                                                                                                                type="text" 
                                                                                                                                className="form-control rounded-0 text-end d-none" 
                                                                                                                                name="trainee_name" 
                                                                                                                                data-id={el_t.id}
                                                                                                                                value={el_t.trainee_name !== undefined && el_t.trainee_name !== null ? el_t.trainee_name : ''}
                                                                                                                                onBlur={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                            />
                                                                                                                            <button class="btn btn-secondary rounded-0" type="button" onClick={() => remove_row_trainees(el_settings.id, el_t.id, formation_active.current)}><i className="bi bi-x-lg"></i></button>
                                                                                                                        </div>
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <select
                                                                                                                            name="trainee_participated"
                                                                                                                            data-id={el_t.id}
                                                                                                                            className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                            value={el_t.trainee_participated !== undefined && el_t.trainee_participated !== null ? el_t.trainee_participated : ''}
                                                                                                                        >
                                                                                                                            <option value="">{language[lang].field_choose}</option>
                                                                                                                            <option value="true">{language[lang].field_yes}</option>
                                                                                                                            <option value="false">{language[lang].field_no}</option>
                                                                                                                        </select>
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <input
                                                                                                                            type="date" 
                                                                                                                            className="form-control rounded-0 text-end"
                                                                                                                            name="trainee_date_end" 
                                                                                                                            value={el_t.trainee_date_end !== undefined && el_t.trainee_date_end !== null ? el_t.trainee_date_end : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td>                                                                                                                
                                                                                                                        <select
                                                                                                                            name="external_evaluation"
                                                                                                                            data-id={el_t.id}
                                                                                                                            className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                            value={el_t.external_evaluation !== undefined && el_t.external_evaluation !== null ? el_t.external_evaluation : ''}
                                                                                                                        >
                                                                                                                            <option value="">{language[lang].field_choose}</option>
                                                                                                                            <option value="true">{language[lang].field_yes}</option>
                                                                                                                            <option value="false">{language[lang].field_no}</option>
                                                                                                                        </select>
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <select
                                                                                                                            name="external_responsable"
                                                                                                                            data-id={el_t.id}
                                                                                                                            className="form-select form-control rounded-0"
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                            value={el_t?.external_responsable_?.id !== undefined && el_t?.external_responsable_?.id !== null ? el_t.external_responsable_.id : ''}
                                                                                                                        >
                                                                                                                            <option value="">{language[lang].field_choose}</option>
                                                                                                                            {
                                                                                                                            entities_list.current !== undefined && entities_list.current !== null ?
                                                                                                                                entities_list.current.map((el_el, k_el) => (
                                                                                                                                    <option key={k_el} value={el_el.id}>
                                                                                                                                        {el_el.label}
                                                                                                                                    </option>
                                                                                                                                ))
                                                                                                                            :
                                                                                                                                null
                                                                                                                            }
                                                                                                                        </select>

                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end d-none" 
                                                                                                                            name="external_responsable" 
                                                                                                                            value={el_t.external_responsable !== undefined && el_t.external_responsable !== null ? el_t.external_responsable : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end" 
                                                                                                                            name="external_classification" 
                                                                                                                            value={el_t.external_classification !== undefined && el_t.external_classification !== null ? el_t.external_classification : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <select
                                                                                                                            name="internal_responsable"
                                                                                                                            data-id={el_t.id}
                                                                                                                            className="form-select form-control rounded-0"
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                            value={el_t?.internal_responsable_?.id !== undefined && el_t?.internal_responsable_?.id !== null ? el_t.internal_responsable_.id : ''}
                                                                                                                        >
                                                                                                                            <option value="">{language[lang].field_choose}</option>
                                                                                                                            {
                                                                                                                            entities_list.current !== undefined && entities_list.current !== null ?
                                                                                                                                entities_list.current.map((el_el, k_el) => (
                                                                                                                                    <option key={k_el} value={el_el.id}>
                                                                                                                                        {el_el.label}
                                                                                                                                    </option>
                                                                                                                                ))
                                                                                                                            :
                                                                                                                                null
                                                                                                                            }
                                                                                                                        </select>
                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end d-none" 
                                                                                                                            name="internal_responsable" 
                                                                                                                            value={el_t.internal_responsable !== undefined && el_t.internal_responsable !== null ? el_t.internal_responsable : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end" 
                                                                                                                            name="internal_classification" 
                                                                                                                            value={el_t.internal_classification !== undefined && el_t.internal_classification !== null ? el_t.internal_classification : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end" 
                                                                                                                            name="global_classification" 
                                                                                                                            value={el_t.global_classification !== undefined && el_t.global_classification !== null ? el_t.global_classification : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        <select
                                                                                                                            name="eficacia"
                                                                                                                            data-id={el_t.id}
                                                                                                                            className="form-select form-control rounded-0"
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                            value={el_t?.eficacia_?.id !== undefined && el_t?.eficacia_?.id !== null ? el_t.eficacia_.id : ''}
                                                                                                                        >
                                                                                                                            <option value="">{language[lang].field_choose}</option>
                                                                                                                            {
                                                                                                                            classificacao_eficacia_list.current !== undefined && classificacao_eficacia_list.current !== null ?
                                                                                                                                classificacao_eficacia_list.current.map((el_el, k_el) => (
                                                                                                                                    <option key={k_el} value={el_el.id}>
                                                                                                                                        {el_el.label}
                                                                                                                                    </option>
                                                                                                                                ))
                                                                                                                            :
                                                                                                                                null
                                                                                                                            }
                                                                                                                        </select>
                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end d-none" 
                                                                                                                            name="eficacia" 
                                                                                                                            value={el_t.eficacia !== undefined && el_t.eficacia !== null ? el_t.eficacia : ''}
                                                                                                                            data-id={el_t.id}
                                                                                                                            onChange={(e) => change_trainees_values(e, formation_active.current)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            )
                                                                                                        })
                                                                                                    :
                                                                                                        null
                                                                                                    }
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-md-4"></div>

                                                                                <div className="col-12 col-md-8 text-end mt-4">
                                                                                    <div className="input-group">
                                                                                        <span className="input-group-text rounded-0">{language[lang].field_final_evaluation}</span>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="media_global"
                                                                                            data-id={el_settings.id}
                                                                                            value={el_settings?.media_global !== undefined && el_settings?.media_global !== null ? el_settings?.media_global : ''}
                                                                                            onChange={(e) => change_settings(e)}
                                                                                            className="form-control rounded-0" 
                                                                                        />
                                                                                        <select
                                                                                            name="eficacia_global"
                                                                                            data-id={el_settings.id}
                                                                                            className="form-select form-control rounded-0"
                                                                                            onChange={(e) => change_settings(e)}
                                                                                            value={el_settings?.eficacia_global !== undefined && el_settings?.eficacia_global !== null ? el_settings?.eficacia_global : ''}
                                                                                        >
                                                                                            <option value="">{language[lang].field_choose}</option>
                                                                                            {
                                                                                            classificacao_eficacia_list.current !== undefined && classificacao_eficacia_list.current !== null ?
                                                                                                classificacao_eficacia_list.current.map((el_el, k_el) => (
                                                                                                    <option key={k_el} value={el_el.id}>
                                                                                                        {el_el.label}
                                                                                                    </option>
                                                                                                ))
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </select>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="eficacia_global"
                                                                                            data-id={el_settings.id}
                                                                                            value={el_settings?.eficacia_global !== undefined && el_settings?.eficacia_global !== null ? el_settings?.eficacia_global : ''}
                                                                                            onChange={(e) => change_settings(e)}
                                                                                            className="form-control rounded-0 d-none" 
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        :
                                                            null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}